import React from 'react';
import SpecialInitiativesForm from './SpecialInitiativesForm';

const SpecialInitiativesCreate = (props) => (
    <SpecialInitiativesForm {...props} mode="create" />
);

export default SpecialInitiativesCreate;
